const paginationBtnClass =
    "flex h-[25px] w-[25px] select-none items-center justify-center rounded-[5px] border border-nt-blue disabled:cursor-not-allowed disabled:opacity-40";

const TablePagination = ({ pageButtonCount, totalPages, pagination, pages }) => {
    return (
        <div className="mt-5 flex justify-between">
            <div className="text-nt-blue">Total pages: {totalPages}</div>
            {totalPages > 0 ? (
                <div className="flex justify-end gap-2.5">
                    <button
                        type="button"
                        className={paginationBtnClass}
                        disabled={pagination.state.page === 0}
                        onClick={() => pagination.fns.onSetPage(pagination.state.page - 1)}
                    >
                        {"<"}
                    </button>
                    {pages.map((_, index) => {
                        if (
                            (pagination.state.page - index < pageButtonCount &&
                                pagination.state.page + pageButtonCount > index) ||
                            (pagination.state.page === totalPages - 1 &&
                                pagination.state.page - pageButtonCount <= index) ||
                            (pagination.state.page === 0 && index <= pageButtonCount)
                        )
                            return (
                                <button
                                    key={index}
                                    type="button"
                                    className={
                                        paginationBtnClass +
                                        (pagination.state.page === index ? " bg-nt-blue text-white" : "")
                                    }
                                    onClick={() => pagination.fns.onSetPage(index)}
                                >
                                    {index + 1}
                                </button>
                            );
                    })}
                    <button
                        type="button"
                        className={paginationBtnClass}
                        onClick={() => pagination.fns.onSetPage(pagination.state.page + 1)}
                        disabled={totalPages - 1 === pagination.state.page}
                    >
                        {">"}
                    </button>
                </div>
            ) : null}
        </div>
    );
};

export { TablePagination };
